import {Injectable} from '@angular/core';
import {Attachment} from "../store/entities/shared/attachment.model";
import * as fromGql from "../store/entities/shared/attachment.graphql";
import {NotificationService} from "./notification.service";
import {GraphqlService} from "./graphql.service";
import {BaseResponse} from "../common/interfaces/global-interfaces";
import {ViewPdfInPopupComponent} from "../shared/components/view-pdf-in-popup/view-pdf-in-popup.component";
import {MatDialog} from "@angular/material/dialog";
import {Store} from "@ngrx/store";
import {AppState} from "../store";
import {setLoadingState} from "../store/entities/shared/loading-state/loading-state.actions";

@Injectable({
  providedIn: 'root'
})
export class AttachmentService {

  constructor(
    private notificationService: NotificationService,
    private apollo: GraphqlService,
    private dialog: MatDialog,
    private store: Store<AppState>
  ) {
  }

  async saveAttachment(base64String: string, fileName: string): Promise<Attachment> {
    try {
      this.store.dispatch(setLoadingState({loadingState: {id: 'attachmentUpload', isLoading: true}}))
      const response = await this.apollo.mutate({
        mutation: fromGql.UPLOAD_ATTACHMENT,
        variables: {input: {base64String, fileName}}
      });
      const result: BaseResponse<Attachment> = Object.values(Object.values(response)[0])[0];
      this.store.dispatch(setLoadingState({loadingState: {id: 'attachmentUpload', isLoading: false}}))
      if (result?.response?.status) {
        return result.data;
      } else {
        throw Error(result.response.message)
      }
    } catch (e) {
      this.notificationService.errorMessage(e?.message);
    }
    return null;
  }

  async readAttachment(filePath: string): Promise<Attachment> {
    try {
      this.store.dispatch(setLoadingState({loadingState: {id: 'attachmentRead', isLoading: true}}))
      const response = await this.apollo.query({
        query: fromGql.READ_ATTACHMENT_BY_PATH,
        variables: {filePath}
      });
      const result: BaseResponse<Attachment> = Object.values(Object.values(response)[0])[0];
      this.store.dispatch(setLoadingState({loadingState: {id: 'attachmentRead', isLoading: false}}))
      if (result?.response?.status) {
        return result.data;
      } else {
        throw Error(result.response.message)
      }
    } catch (e) {
      this.notificationService.errorMessage(e?.message);
    }
    return null;
  }


  async viewPdfInModal(base64: string, title = 'PDF Attachment', width = '80%', fileType: 'PDF' | 'IMAGE' | 'VIDEO' | 'AUDIO' = 'PDF') {
    const dialogRef = this.dialog.open(ViewPdfInPopupComponent, {
      width,
      data: {base64, title, fileType}
    });
    return dialogRef.afterClosed();
  }

}
